export default __webpack_public_path__ + "static/media/total_schemes.2a71be6d.svg";